
import { Component, Vue, Prop, computed } from 'vue-property-decorator'

@Component({
  components: {
  }
})
export default class VideoCard extends Vue {
  @Prop({ required: true })readonly id: number
  @Prop({ required: true })readonly title: string
  @Prop({ required: true })readonly description: string
  @Prop({ required: true })readonly duration: number
  @Prop({ required: true })readonly ytbId: string
  data () {
    return {
      imageUrl: ''
    }
  }

  mounted () {
    this.imageUrl = `https://img.youtube.com/vi/${this.ytbId}/maxresdefault.jpg`
  }

  replaceUnicodes (value) {
    var regex = /\\n/g
    var r = value.replaceAll(regex, '<br>').replace(/\\U(........)/g, (match, p1) => { return String.fromCodePoint(parseInt(p1, 16)) }).replace(/\\u(....)/g, (match, p1) => String.fromCharCode(parseInt(p1, 16))).replace(/\\(\d{3})/g, (match, p1) => String.fromCharCode(parseInt(p1, 8)))
    return r
  }

  get isLoggedIn () {
    return this.$store.state.loggedIn
  }

  goToVideo () {
    window.location.href = `/home/video/${this.id}`
  }
}
